/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import badGenderType from './badGenderType.js'
import duplicateTypes from './duplicateTypes.js'
import invalidREV from './invalidREV.js'
import missingFN from './missingFN.js'

export default [
	badGenderType,
	duplicateTypes,
	invalidREV,
	missingFN,
]
